import { createFileRoute } from "@tanstack/react-router";
import { InternalTrackingPage } from "../../../../pages/chrono-devis-list-page/organisation-internal-tracking/internal-tracking-page";

export const Route = createFileRoute("/_auth/_frame/chrono-devis/internal-tracking")({
  component: InternalTrackingPage,
});
